import axios from 'axios';

const state = {
    permissions: [],
};

const getters = {
    getPermissions(state) {
        return state.permissions;
    },
};

const mutations = {
    setPermissions(state, payload) {
        state.permissions = payload;
    },
};

const actions = {
    get(ctx){
        return new Promise( (resolve, reject) => {
            axios.get('/users/me/permissions').then((response) => {
                ctx.commit('setPermissions', response.data);
                resolve(response.data);
            })
                .catch((error) => {
                    reject(error);
                })
        });
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
}